<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import callAPI from "../../../api/http";
import { convertChartDate } from "../../../js/date";
import err from "../../../js/error";
import moment from "moment";

export default {
  extends: Line,
  props: ["label"],
  mixins: [reactiveProp],

  data() {
    return {
      chartData: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          yAxes: [
            {
              display: false
            }
          ],

          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },

        legend: {
          display: false
        }
      },
      gradient: null,
      chartPeriod: 28,
      today: new Date(),
      layout: "YYYY-MM-DD"
    };
  },

  async mounted() {

    const { data, errCode } = await callAPI(
      `get${this.label}History`
    );

    if (errCode) {
      console.log(errCode);
      return;
    }

    this.setChartBackgroundColor();
    this.setChartData(data);
    this.renderChart(this.chartData, this.options);
  },

  methods: {
    setChartBackgroundColor() {
      this.gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);

      this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
      this.gradient.addColorStop(0.25, "rgba(255, 0, 0, 0.3)");
      this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
      this.gradient.addColorStop(0.75, "rgba(255, 0, 0, 0.1)");
      this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");
    },

    setChartData({ chart }) {
      const { newDate, newCount } = convertChartDate(chart);

      this.chartData = {
        labels: newDate, // x-axis
        datasets: [
          {
            label: this.label,
            backgroundColor: this.gradient,
            borderColor: "#FC2525",
            borderWidth: 1,
            pointBackgroundColor: "#FFF",
            pointBorderColor: "#FC2525",
            fill: true,
            pointHoverRadius: 6,
            pointRadius: 2.5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            data: newCount // y-axis
          }
        ]
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/contents/shared/Chart.vue